import * as _ from "lodash";
import * as Backbone from "backbone";
import {
    DashboardChannelView,
    DashboardInstallView,
    DashboardNotificationView,
    DashboardTeamView,
    DashboardUserView
} from "./DashboardDetailViews";
import {BaseAccountOverviewView} from "../_BaseAccountViews";
import {DashboardChannelCollection} from "../../../collections/DashboardChannels";

export class DashboardOverviewView extends BaseAccountOverviewView {
    private currentDashboard: Backbone.Model;
    private dashboardChannelCollection: DashboardChannelCollection = null;

    show(dashboardId, detail?, subDetail?) {
        this.currentDetail = detail;
        this.currentDashboard = this.options.dashboardCollection.findWhere({id: Number(dashboardId)});
        this.dashboardChannelCollection = new DashboardChannelCollection([], {dashboardId: Number(dashboardId)});

        this.collectionLoaded = true;
        this.render();

        // If there is a detail render it exclusively
        if (detail) {
            this.renderSubViews(detail, false);
            return;
        }

        // Otherwise render all details
        _.each(['teams', 'users', 'installs', 'channels', 'notifications'], (viewClass) => {
            this.renderSubViews(viewClass, true);
        });
    }

    render() {
        this.$el.html(this.template({
            collectionLoaded: this.collectionLoaded,
            title: this.currentDashboard ? this.currentDashboard.get('name') : '',
            canView: true
        }));

        this.showBreadcrumbs();
        (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        this.delegateEvents();
        return this;
    }

    showBreadcrumbs() {
        if (!this.options.currentOrganizationId || !this.currentDashboard) return;
        var orgId = this.options.currentOrganizationId;
        var dashboardId = this.currentDashboard.get('id');

        var routeString = '/#/account/' + orgId + '/dashboards/' + dashboardId;
        this.breadcrumbPathMap = {
            [this.currentOrganization.get('name')]: '/#/account/' + orgId,
            'Dashboards': '/#/account/' + orgId + '/dashboards'
        };

        var currentPath, searchByX;
        if (this.currentDetail) {
            this.breadcrumbPathMap[this.currentDashboard.get('name')] = routeString;

            searchByX = 'Dashboard Details';
            this.breadcrumbDropDownOptions = {
                'Users': routeString + '/users',
                'Teams': routeString + '/teams',
                'Installs': routeString + '/installs',
                'Channels': routeString + '/channels',
                'Notifications': routeString + '/notifications',
            };
            currentPath = _.capitalize(this.currentDetail);
        } else {
            searchByX = 'Dashboard';
            currentPath = this.currentDashboard.get('name');
            this.options.dashboardCollection.each((d) => {
                this.breadcrumbDropDownOptions[d.get('name')] = '/#/account/' + orgId + '/dashboards/' + d.get('id');
            });
        }

        super.showBreadcrumbs(currentPath, searchByX);
    }

    renderSubViews(detail, isOverview) {
        var options = {
            currentDashboard: this.currentDashboard,
            groupPermissionCollections: this.groupPermissionCollections,
            dashboardChannelCollection: this.dashboardChannelCollection,
            isOverview: isOverview
        };

        var subview;
        switch (detail) {
            case 'teams':
                subview = new DashboardTeamView(_.extend({}, this.options, options));
                break;
            case 'users':
                subview = new DashboardUserView(_.extend({}, this.options, options));
                break;
            case 'installs':
                subview = new DashboardInstallView(_.extend({}, this.options, options));
                break;
            case 'channels':
                subview = new DashboardChannelView(_.extend({}, this.options, options));
                break;
            case 'notifications':
                subview = new DashboardNotificationView(_.extend({}, this.options, options));
                break;
        }

        if (subview) {
            this.subViews.push(subview);
            this.$('.container').append(subview.render().$el);
            subview.show();
        }
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/account/dashboards/DashboardOverviewView.ts